<template>
  <Modal :closeBtn="true" @close="emit('close')" :styleOptions="defaultLoanOptionsStyle">
    <pel-loan-options
      v-if="!loading"
      id="multiple-term-loanOptions"
      :isCurrent="true"
      :showPreviousButton="false"
      :loading="loading"
      @complete="$emit('complete', $event)"
  /></Modal>
</template>

<script setup lang="ts">
import { computed, defineProps, withDefaults, defineEmits } from "vue";
import Modal from "@/components/shared/Modal.vue";
import PelLoanOptions from "@/components/pel-loan-configuration/PelLoanOptions.vue";

interface Props {
  loading?: boolean;
}

const props = withDefaults(defineProps<Props>(), {
  loading: false,
});

const emit = defineEmits<{
  (e: "close"): void;
  (e: "complete", payload?: any): void;
}>();

const defaultLoanOptionsStyle = computed(() => {
  return {
    modalContainer: {
      maxWidth: "100%",
    },
  };
});
</script>
